import {Component} from 'react';
import {generatePath, RouteComponentProps} from 'react-router';
import {convertDraftBooking, createDraftBooking, saveDraftBooking} from 'services/bookings/drafts';
import {loadBooking} from 'services/bookings';
import RouteURLs from 'RouteURLs';
import NextRouteURLs from 'NextRouteURLs';
import queryString from 'querystring';
import {handleError} from 'util/errors';
import {loadSpace} from 'services/spaces';

interface EditBookingPageProps extends RouteComponentProps<{code?: string}> {
}

export default class EditBookingPage extends Component<EditBookingPageProps> {
  componentDidMount(): void {
    if(this.props.match.params.code) {
      // editing an existing booking
      loadBooking(this.props.match.params.code).then(
        booking => {
          const DraftBooking = convertDraftBooking(booking);
          saveDraftBooking(DraftBooking);
          this.props.history.replace(generatePath(RouteURLs.EDIT_BOOKING_TIME, {code: booking.code}));
        },
        () => this.props.history.replace(RouteURLs.NOT_FOUND)
      );
    } else {
      // creating a new booking
      const qs = queryString.parse(this.props.location.search.replace('?', ''));
      const spaceCode = qs.space as string;
      const date = qs.date as string;
      EditBookingPage.createNewBooking(spaceCode).then(
        () => this.props.history.replace(RouteURLs.CREATE_BOOKING_TIME + (date ? `?date=${date}` : '')),
        err => {
          handleError('Failed to create booking', err);
          this.props.history.replace(NextRouteURLs.SPACES);
        }
      );
    }
  }

  static async createNewBooking(spaceCode: string) {
    if(!spaceCode) {
      throw new Error("Space not set");
    }
    const space = await loadSpace(spaceCode);
    if(!space.bookingEnabled) {
      throw new Error("Booking not enabled on space");
    }
    const booking = await createDraftBooking(space.code);
    saveDraftBooking(booking);
    return booking;
  }

  render() {
    return null;
  }
}